import axios from "axios";
import { useEffect } from "react";

const MyPortalHooks = () => {
  return new Promise((resolve) => {
    axios
      .get(`${process.env.REACT_APP_NODE_URL}/orders/order-list-new`, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => console.log(error));
  });
};

const ApproveOrderHook = (data) => {
  return new Promise((resolve) => {
    axios
      .put(`${process.env.REACT_APP_NODE_URL}/orders/approve-order`, data, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => console.log(error));
  });
};
const RejectOrderHook = (data) => {
  return new Promise((resolve) => {
    axios
      .put(`${process.env.REACT_APP_NODE_URL}/orders/reject-order`, data, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => console.log(error));
  });
};

const HoldOrderHook = (order_id, comment) => {
  return new Promise((resolve) => {
    axios
      .put(`${process.env.REACT_APP_NODE_URL}/orders/update`, {
        doi_id: order_id,
        updateData: {
          status: 8,
          comment: comment,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => console.log(err));
  });
};

const downloadFileHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .get(`${process.env.REACT_APP_NODE_URL}/orders/downloadFile/` + data, {
        withCredentials: true,
      })
      .then((response) => {
        const responseURL = response.data;
        if (responseURL.status === 500) {
          resolve({ status: 500 });
        } else {
          axios
            .post("https://s3bucket-node.superhaves.com/preSignedURL", {
              key: responseURL.data.file_name,
            })
            .then((res) => resolve(res.data))
            .catch((err) => console.log(err));
        }
        // resolve(response.data);
      })
      .catch((err) => console.log(err));
  });
};
export {
  MyPortalHooks,
  ApproveOrderHook,
  RejectOrderHook,
  downloadFileHooks,
  HoldOrderHook,
};
